import {
  AppUserRole,
  ShelterRosterRole,
} from '../../../constants/appUserRole';
import type { AuthUserProfile } from '../../auth/types/auth';

/** Short label under the user name in the admin top bar (Gentle Paws–style subtitle). */
export function formatToolbarRole(user: AuthUserProfile): string {
  const { role, shelterRole } = user;
  if (role === AppUserRole.SUPER_ADMIN) return 'Super admin';
  if (role === AppUserRole.SHELTER_ADMIN) return 'Shelter admin';
  if (role === AppUserRole.USER && shelterRole === ShelterRosterRole.ADMIN) {
    return 'Team admin';
  }
  if (role === AppUserRole.USER) return 'Adoption team';
  return role;
}
